export default __webpack_public_path__ + "static/media/SevenDays.1f81948d.svg";